import { ExternalProductSearch } from '@/@types';
import configuration from '@/configuration';
import { PeoopleError } from '@/utils/error';

const _request = async ({ url, method = 'GET', params, data }: { url: string; method?: string; params?: any; data?: any }) => {
  const queryString = new URLSearchParams(params);

  const makeRequest = () => {
    return fetch(`https://places.googleapis.com/v1/places${url}?${queryString.toString()}`, {
      headers: {
        'X-Goog-Api-Key': configuration.map.key,
      },
      body: JSON.stringify(data),
      method,
    }).then((res) => {
      if (!res.ok) {
        return res
          .json()
          .catch(() => {
            return { statusCode: res.status, message: res.statusText };
          })
          .then((err) => {
            return Promise.reject(PeoopleError(err.message, err.statusCode));
          });
      }

      return res.headers.get('content-type')?.includes('application/json') ? res.json() : res.text();
    });
  };
  return makeRequest();
};

const places = () => {
  return {
    _request,
    search: async ({ location, query }: { location: any; query: string }): Promise<ExternalProductSearch[]> => {
      return _request({
        url: ':autocomplete',
        method: 'post',
        data: {
          input: query,
          includedPrimaryTypes: ['restaurant'],
          locationBias: location
            ? {
                circle: {
                  center: location,
                  radius: 500.0,
                },
              }
            : undefined,
        },
      }).then(({ suggestions }) => {
        return suggestions.map((result) => {
          return {
            name: result.placePrediction.structuredFormat.mainText.text,
            details: result.placePrediction.structuredFormat.secondaryText.text,
            externalId: result.placePrediction.placeId,
          } as ExternalProductSearch;
        });
      });
    },
  };
};

export default places;
